import { Card, Divider, Empty, message, Skeleton, Tabs } from "antd";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { ChannelType } from "../../contexts/channels/ChannelProvider";
import {
  PaymentContext,
  PaymentContextProvider,
  PaymentContextType,
} from "../../contexts/payment/PaymentContext";
import { thousandSeparator } from "../../helpers/thousand_separator";
import { ChannelModel } from "../../models/ChannelModel";
import "./payment.css";
import { DonationSingleResultInterface } from "../../contexts/payment/interfaces/donation-single-result.interface";
import axios from "axios";
import { CompanySingleResultInterface } from "../../models/CompanyModel";
import QRCode from "react-qr-code";
import {
  ALFAMARTIPaymu,
  BCAVAIPaymu,
  BNIVAIPaymu,
  BRIVAIPaymu,
  INDOMARETIPaymu,
  MANDIRIVAIPaymu,
  QRISIPaymu,
} from "../../contexts/channels/interfaces/midtrans-channel";

function PaymentIPayMuToupV2() {
  return (
    <PaymentContextProvider>
      <PaymentState />
    </PaymentContextProvider>
  );
}

function PaymentState() {
  const [channel, setChannel] = React.useState<ChannelModel>();
  const {
    // paymentResultIpaymu,
    // doPaymentIpaymu,
    // initPayment,
    // getDonationDetail,
    // donationDetail,
    // getDonationDetailForStatus,
    // donationDetailForStatus,
    // donationDetailLoading,
  } = React.useContext(PaymentContext) as PaymentContextType;
  const [vaNumber, setVaNumber] = React.useState<string | undefined>(
    "123456789"
  );
  const [qrCode, setQrCode] = React.useState<string>();
  const [deeplink, setDeeplink] = React.useState<string>();
  const [bankCode, setBankCode] = React.useState<string>();
  const [donationResult, setDonationResult] =
    React.useState<DonationSingleResultInterface>(undefined);
  const params = useParams();
  const {
    walletDetail,
    getWalletDetail,
    getWalletDetailStatus,
    walletDetailStatus,
    doPaymentTopupIpaymuV2,
    loading,
    paymentResultIpaymu,
  } = useContext<PaymentContextType>(PaymentContext);

  React.useEffect(() => {
    if (params) {
      if (params["invoice_code"] !== undefined) {
        // getDonationDetail(params["invoice_code"] as string);
        getWalletDetail(params["invoice_code"] as string);

        // get donation status every 5 seconds
        const interval = setInterval(() => {
          getWalletDetailStatus(params["invoice_code"] as string);
        }, 5000);
        // Stop the interval when the component unmounts
        return () => clearInterval(interval);
      }
    }
  }, []);

  React.useEffect(() => {
    if (walletDetail !== undefined) {
      switch (walletDetail?.data?.payment_name?.toLowerCase()) {
        case "bca virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...BCAVAIPaymu,
          });
          break;
        case "mandiri virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...MANDIRIVAIPaymu,
          });
          break;
        case "qris":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...QRISIPaymu,
          });
          break;
        case "alfamart":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...ALFAMARTIPaymu,
          });
          break;
        case "indomaret":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...INDOMARETIPaymu,
          });
          break;
        case "bni virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...BNIVAIPaymu,
          });
          break;
        case "bri virtual account":
          setChannel({
            id: walletDetail?.data?.payment_id,
            ...BRIVAIPaymu,
          });
          break;
      }
    }
  }, [walletDetail]);

  React.useEffect(() => {
    if (walletDetailStatus !== undefined) {
      if (
        walletDetailStatus?.data?.status === "settlement" ||
        walletDetailStatus?.data?.status === "capture"
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            console.log(response);
            const url = `${response?.data?.platform_donation}/payment/success-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=success`;
            window.location.href = url;
          });
      } else if (
        walletDetailStatus?.data?.status === "cancel" ||
        walletDetailStatus?.data?.status === "deny"
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/failed-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=failed`;
            window.location.href = url;
          });
      } else if (walletDetailStatus?.data?.status === "expire") {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/timeout-topup?invoice_code=${walletDetailStatus?.data?.invoice_code}&result=expire`;
            window.location.href = url;
          });
      }
    }
  }, [walletDetailStatus]);

  React.useEffect(() => {
    if (channel) {
      // doPayment(channel, encrypt);
      // setVaNumber(channel.account_number);
      if (channel.type !== ChannelType.EWALLET) {
        if (channel.additional_text) {
          if (channel.additional_text.length > 0) {
            setBankCode(channel.additional_text[0]);
          }
        }
      }
    }
  }, [channel]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (walletDetail !== undefined && channel !== undefined) {
      console.log(walletDetail);
      doPaymentTopupIpaymuV2(channel);
    }
  }, [walletDetail, channel]);

  React.useEffect(() => {
    if (paymentResultIpaymu?.status) {
      setVaNumber(paymentResultIpaymu?.data?.Data?.PaymentNo);
      setQrCode(paymentResultIpaymu?.data?.Data?.QrImage);
    }
  }, [paymentResultIpaymu]);

  return (
    <div
      style={{
        margin: 20,
      }}
    >
      <Skeleton loading={loading}>
        <h1>{channel?.title}</h1>
        <h2>{channel?.subtitle}</h2>
        {paymentResultIpaymu?.status &&
        paymentResultIpaymu?.data?.Status === 200 ? (
          <>
            <Card
              hoverable
              style={{
                marginBottom: 10,
              }}
            >
              <p className="amount">Jumlah</p>
              <div
                style={{
                  float: "right",
                }}
              >
                <span className="amount-rp">Rp </span>
                <span className="amount-number">
                  {thousandSeparator(walletDetail?.data?.amount)}
                </span>
              </div>
            </Card>
            {channel?.type === ChannelType.EWALLET && (
              <Card
                hoverable
                style={{
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                <span className="account-number-text">
                  {channel.additional_text ? channel.additional_text[0] : ""}
                </span>
                <br />
                {qrCode !== undefined ? (
                  <div>
                    <QRCode value={paymentResultIpaymu?.data?.Data?.QrString} />
                    <Divider />
                    <img
                      src="/assets/qris-bpd-bali.png"
                      style={{ width: "13em" }}
                      alt="QRIS iPaymu"
                    />
                    <br />
                    <img
                      src="/assets/scan_qris.png"
                      style={{ width: "15em" }}
                      alt="QRIS iPaymu"
                    />
                  </div>
                ) : null}
                {deeplink !== undefined && (
                  <a
                    className="deeplink"
                    target={"_blank"}
                    rel="noreferrer"
                    href={deeplink}
                  >
                    {channel.additional_text
                      ? channel.additional_text[1]
                      : "Error"}
                  </a>
                )}
              </Card>
            )}
            {bankCode && (
              <Card
                hoverable
                style={{
                  marginBottom: 10,
                }}
              >
                <p className="amount">Kode Bank</p>
                <div
                  style={{
                    float: "right",
                  }}
                >
                  <span className="amount-number">{bankCode}</span>
                </div>
              </Card>
            )}
            {channel?.type !== ChannelType.EWALLET ? (
              <Card
                style={{
                  marginBottom: 10,
                }}
              >
                {vaNumber && (
                  <div style={{ float: "left" }}>
                    <span className="account-number-text-block">
                      Nomor Rekening
                    </span>
                    <span className="account-number">{vaNumber}</span>
                    <br />
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        message.info(`Nomor Rekening berhasil di salin.`);
                        navigator.clipboard.writeText(vaNumber);
                      }}
                    >
                      Salin Nomor Rekening
                    </a>
                  </div>
                )}
              </Card>
            ) : (
              <div></div>
            )}
          </>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={paymentResultIpaymu?.data?.Message}
          />
        )}
      </Skeleton>

      <Card hoverable title={"Detail Transaksi"} style={{ marginBottom: 10 }}>
        <span className="transaction-detail-text">Nama Program</span>
        <span className="transaction-detail-description">Topup Wallet</span>
      </Card>

      {channel?.hows?.length > 0 ? (
        <Card hoverable title={"Cara Pembayaran"} style={{ marginBottom: 10 }}>
          <Tabs>
            {channel?.hows?.map((item, index) => (
              <Tabs.TabPane tab={item.name} key={index}>
                {item.steps?.map((item, index) => (
                  <p key={index}>
                    {index + 1}. {item}
                  </p>
                ))}
              </Tabs.TabPane>
            ))}
          </Tabs>
        </Card>
      ) : (
        <></>
      )}
    </div>
  );
}

export default PaymentIPayMuToupV2;
